// import Filter from './../views/Filter'
const Terms = () => import('./../views/Terms');

export default [

    {
        path: "/terms",
        name: "terms",
        component: Terms,
     
    },
 
];